import React from "react";
import Slider from '../../basic/slider';

export default class CommunitySection extends React.Component {

    render() {
        let pages = this.props.pages || [];
        let res = [
            { breakpoint: 768, slidesToShow: 2 }
        ]

        return (
            <div className='pubhub-community'>
                <div className='container'>
                    <div className='pubhub-community-title'>
                        {this.props.title}
                    </div>
                </div>
                <Slider autoPlay={false} res={res} ref={dom => this.slider = dom}>
                    {
                        pages.map((page, index) => {
                            return this.renderPage(page, index);
                        })
                    }
                </Slider>
                <div className='container'>
                    <div className='pubhub-resp-slider-box pubhub-community-action'>
                        <a className='btn btn-lg-wide btn-primary' href={this.props.action.href}>
                            {this.props.action.label}
                        </a>
                    </div>
                </div>
            </div>
        );
    }

    renderPage(page, key) {
        const className = 'pubhub-community-page'
        return (
            <div key={key} className={className}>
                <div className={className + '-frame'}>
                    <div className={className + '-img'} style={{ backgroundImage: `url(${page.pic})` }}></div>
                    <div className={className + '-title'}>
                        <h2>{page.title}</h2>
                    </div>
                    <a className={className + '-mask'} href={page.action.href}>
                        <div className={className + '-action'}>{page.action.label}</div>
                    </a>
                </div>
                <div className={className + '-text'}>
                    <div className={className + '-description'}>{page.description}</div>
                </div>
            </div>
        );
    }
}
